import { LoadState } from "../../../constants/enums";

export interface IBalanceSheetStatementsState {
  list: IBalanceSheetStatement[];
  loading: LoadState;
  totalRecords: number;
}

export interface IBalanceSheetStatement {
  id: string;
  prefix_gl_code_name: string;
  amount: string;
  account_type: string;
  report_heading_account: string;
  query_type: string;
  query_sub_type: string;
}


export const initialBalanceSheetStatementState: IBalanceSheetStatementsState = {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
}